import { createContext, useContext, useMemo } from 'react';

import { getIsProduction } from 'utils';

const RegistrationContext = createContext(null);

function RegistrationProvider({ children }) {
    // TEMP PROD GATE.
    const is404 = getIsProduction();

    const value = useMemo(() => ({ is404 }), [is404]);

    return <RegistrationContext.Provider value={value}>{children}</RegistrationContext.Provider>;
}

function useRegistrationContext() {
    const context = useContext(RegistrationContext);
    if (!context) {
        throw new Error('useRegistrationContext must be used within a RegistrationProvider');
    }
    return context;
}

export { RegistrationProvider, useRegistrationContext };
